import React, { useState } from "react";
import { Modal } from "antd";
import { EditOutlined } from "@ant-design/icons";
import Create from "../create";

export default ({ detail }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <a onClick={() => setOpen(true)}>
        <EditOutlined style={{ marginRight: 8 }} />
        查看
      </a>
      <Modal
        open={open}
        title={"编辑详情"}
        width={800}
        onCancel={() => {
          setOpen(false);
        }}
        onOk={() => {
          setOpen(false);
        }}
      >
        <Create detail={detail} mode="edit" />
      </Modal>
    </>
  );
};
